import './CmsSpinner.css';

// Types
import mixins from "vue-typed-mixins"; // Main
const CmsSpinner = mixins().extend({
  name: 'CmsSpinner',
  props: {
    medium: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  render() {
    const h = arguments[0];
    return h("div", {
      "class": 'cms-spinner mx-auto ' + (this.medium ? 'h-32 w-32 border-10' : this.large ? 'h-48 w-48 border-12' : 'h-16 w-16 border-8')
    });
  }
});
export default CmsSpinner;